import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class ValidateResetPasswordToken {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * RequestToResetPassword constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Send request for password reset.
     *
     * @param {String} token
     * @param {String} email
     *
     * @returns {Promise}
     */
    handle(token, email) {
        let apiUrl = url(ApiEndpoints['auth.validate-token'], [token, email]);

        return this.apiService.get(apiUrl);
    }
}
